import { selectedPartnerProductOrderCartItemsState } from "@/atoms/item/selected-partner-product-order-cart-items-state";
import { useRecoilValue } from "recoil";
import { Body14Medium } from "../typography/Body14Medium";
import { H5 } from "../typography/H5";

interface Props {
  handleSelectAll: () => void;
  handleDeleteSelected: () => void;
  isAllSelected: boolean;
  hasCheckedItems: boolean;
}

export const PartnerProductOrderCartHeader: React.FC<Props> = ({
  handleSelectAll,
  handleDeleteSelected,
  isAllSelected,
  hasCheckedItems,
}) => {
  const cartItems = useRecoilValue(selectedPartnerProductOrderCartItemsState);

  const isSelectAllActive = cartItems.length > 0;
  const isDeleteActive = hasCheckedItems && cartItems.length > 0;

  const selectAllClassName = isSelectAllActive
    ? "text-semantic-text-body cursor-pointer"
    : "text-semantic-text-disabled cursor-not-allowed";

  const deleteClassName = isDeleteActive
    ? "text-semantic-text-body cursor-pointer"
    : "text-semantic-text-disabled cursor-not-allowed";

  return (
    <div className="pt-[24px] px-[16px] pb-[12px] border-b-[1px] border-semantic-divider">
      <div className="py-[12px] flex justify-between items-center">
        <div>
          <H5 className="text-[#3B3B40]">장바구니</H5>
        </div>
        <div className="flex gap-[8px]">
          <div onClick={isSelectAllActive ? handleSelectAll : undefined}>
            <Body14Medium className={selectAllClassName}>
              {isAllSelected ? "전체 해제" : "전체 선택"}
            </Body14Medium>
          </div>
          <div className="h-[22px] w-[1px] bg-semantic-divider" />
          <div onClick={isDeleteActive ? handleDeleteSelected : undefined}>
            <Body14Medium className={deleteClassName}>선택 삭제</Body14Medium>
          </div>
        </div>
      </div>
    </div>
  );
};
